import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import './portal-layout.less';

export const PortalLayout = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <div className="portal-layout">
      <div className="portal-layout-content">
        <div className="portal-layout-info">
          <div className="portal-layout-info-steps">
            <h1>{t('portal.title')}</h1>
            <div className="portal-layout-separator" />
            <div>
              <p>{t('portal.headline')}</p>
              <p>{t('portal.description')}</p>
            </div>
          </div>
        </div>
        <div className="portal-layout-card">{children}</div>
      </div>
    </div>
  );
};
